import { GROUP_ASSIGNMENT_KINDS } from 'cpool-constants';
import { z } from 'zod';

import { schemaId } from '../utils/schema.utils';

export const schemaGroupAssignment = z.object({
    aggregateId: schemaId,
    kind: z.nativeEnum(GROUP_ASSIGNMENT_KINDS),
});

export type SchemaGroupAssignment = z.infer<typeof schemaGroupAssignment>;
